module.exports = __webpack_public_path__ + "static/media/16UNODC15.3adf1245.jpg";